import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {ModelManager} from 'models/managers/ModelManager';
import {getStore} from 'redux-stores/Store';
import {RequestTasksModelSelector} from 'requests/inputs/reduceInputs';
import * as RequestTaskReduxActions from 'requests/tasks/RequestTaskReduxActions';

import {RequestTask} from '../tasks/RequestTaskConstants';

export default class RequestTasksModelManager extends ModelManager<ManagedModelType.REQUEST_TASKS_BY_REQUEST_ID> {
  constructor() {
    super(ManagedModelType.REQUEST_TASKS_BY_REQUEST_ID);
  }

  async doFetchMulti(keys: Array<string>): Promise<void> {
    await getStore().dispatch(RequestTaskReduxActions.fetchTasksForRequests(keys));
  }

  getModel(modelKey: string): Array<RequestTask> | null {
    return new RequestTasksModelSelector(getStore().getState()).getModel(modelKey);
  }
}
